import { StyleSheet } from 'react-native'
import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'yellow'
  },
  bottomSheetHandleStyle: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },

  bottomSheetIndicatorStyle: {
    backgroundColor: 'gray',
    height: 4,
    width: 39
  }
})
